import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Method from './components/Method';
import Differentials from './components/Differentials';
import SuccessStories from './components/SuccessStories';
import Methodology from './components/Methodology';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Method />
      <Differentials />
      <SuccessStories />
      <Methodology />
      <Footer />
    </div>
  );
}

export default App;
